import { Link } from 'react-router';
import { Icon } from './Icon';

interface Contact {
  address?: string;
  email?: string;
  phone?: string;
}

export function ContactHeader({ contact }: { contact: Contact }) {
  return (
    <div className="hidden px-4 sm:px-6 lg:block">
      <div className="relative mx-auto max-w-screen-xl border-b border-green-200/30 py-5">
        <div className="flex items-center justify-between">
          <div className="w-60 flex-shrink-0 flex-grow-0">
            <Link to="/">
              <img src={'/images/logo.png'} alt="Шинэ Өнөөдөр Сургууль" className="h-auto" />
            </Link>
          </div>
          <ul className="ml-8 flex lg:space-x-6 xl:space-x-16">
            <li className="flex max-w-xs flex-shrink">
              <div>
                <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-yellow-400">
                  <Icon icon="mapPin" className="h-6 w-6 text-green-700" />
                </span>
              </div>
              <div className="ml-3 mt-0 flex-1 xl:ml-4">
                <h5 className="flex items-center text-base font-semibold text-green-900">Хаяг</h5>
                <p className="mt-0.5 text-sm leading-relaxed text-green-800 text-opacity-90">
                  {contact.address}
                </p>
              </div>
            </li>
            <li className="flex flex-shrink-0">
              <div>
                <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-green-200">
                  <Icon icon="mail" className="h-6 w-6 text-green-700" />
                </span>
              </div>
              <div className="ml-3 flex-1 xl:ml-4">
                <h5 className="flex items-center text-base font-semibold text-green-900">И-мэйл</h5>
                <p className="mt-0.5 text-sm leading-relaxed text-green-800 text-opacity-90">
                  {contact.email}
                </p>
              </div>
            </li>
            <li className="flex flex-shrink-0">
              <div>
                <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-rose-200">
                  <Icon icon="phone" className="h-6 w-6 text-green-700" />
                </span>
              </div>
              <div className="ml-3 flex-1 xl:ml-4">
                <h5 className="flex items-center text-base font-semibold text-green-900">Утас</h5>
                <p className="mt-0.5 text-sm leading-relaxed text-green-800 text-opacity-90">
                  {contact.phone}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
